import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../../APIServices/studyEDCLupReportingServices";

const AddNewLUPReport = ({ getLupReportMetadatasData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [reportName, setReportName] = useState("");
  const [reportNumber, setReportNumber] = useState("");
  const [reportType, setReportType] = useState("");
  const [reportDescription, setReportDescription] = useState("");
  const [category, setCategory] = useState([]);
  let { studyId } = useParams();

  const getLupReportCategorysData = async (e) => {
    let data = await studyEDCLupReportingServices.getLupReportCategorysData(
      "active", 
      studyId,
    );
    setCategory(data?.data || []);
  };

  const addNewLupReportMetadata = async () => {
    let userData = {};
    setButtonLoader(true);
    userData.reportName = reportName;
    userData.reportNumber = reportNumber;
    userData.reportType = reportType;
    userData.reportDescription = reportDescription;
    userData.studyId = studyId;
    let data = await studyEDCLupReportingServices.addNewLupReportMetadata(
      userData
    );
    if (data?.statusCode === 200) {
      getLupReportMetadatasData();
      setReportName("");
      setReportNumber("");
      setReportType("");
      setReportDescription("");
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    getLupReportCategorysData();
  }, []);

  return (
    <>
      <div className="p-2">
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Report Number{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            className="fontSize12"
            placeholder="Enter Report Number"
            onChange={(e) => setReportNumber(e.target.value)}
            value={reportNumber}
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Report Name{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            className="fontSize12"
            placeholder="Enter Report Name"
            onChange={(e) => setReportName(e.target.value)}
            value={reportName}
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Report Type{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Select
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="">Select Report Type</option>
            {category?.length > 0 &&
              category?.map((item, key) => (
                <option value={item.categoryId} key={key}>
                  {item.name}
                </option>
              ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Report Description{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            className="fontSize12"
            placeholder="Enter Report Description"
            onChange={(e) => setReportDescription(e.target.value)}
            value={reportDescription}
          />
        </Form.Group>
        <div className="text-end">
          <button
            onClick={addNewLupReportMetadata}
            disabled={!reportName || buttonLoader}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add Report"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddNewLUPReport;
